// addressComponent.js
import React from 'react';
import HoursComponent from './hoursComponent';


const AddressComponent = ({
  address,
  scroll,
  active,
  barlow,
  isVirtual,
  colorWhite,
  colorBlack,
  isOpen,
  closedAt,
  opensAt,
  showHours,
  hours,
  handleShowHours,
  htmlId,
}) => {
  return (
    <h3
      className={
        (!scroll && !active ? colorWhite : colorBlack) +
        ' navbar-item ' +
        barlow
      }
      style={{ position: 'relative', top: '-0.5rem' }}
    >
      {address}
      <HoursComponent
        isOpen={isOpen}
        isVirtual={isVirtual}
        closedAt={closedAt}
        opensAt={opensAt}
        showHours={showHours}
        hours={hours}
        handleShowHours={handleShowHours}
        scroll={scroll}
        active={active}
        barlow={barlow}
        colorWhite={colorWhite}
        colorBlack={colorBlack}
        htmlId={htmlId}
      />
    </h3>
  );
};

export default AddressComponent;
